import React, {useState} from "react";

const Contact = () => {

    const handleClick = (channel) => { // #added 28/3/25 TG
        // alert("Button click coming soon, thanks for clicking our button!");
        console.log("button clicked", channel);
        if (channel === "email") {
            // window.location.href = "mailto:oscar@eleven.fit";
            setPopSection(1); // que despliegue su email arriba 30/3/25 TG TG
        } else if (channel === "instagram") {
            window.location.href = "https://www.instagram.com/oscar.eleven.fit/";
        } else if (channel === "youtube") {
            window.location.href = "https://www.youtube.com/@oscarelevenfit";
        } else if (channel === "tiktok") {
            window.location.href = "https://www.tiktok.com/@oscar.eleven.fit";
        }/* else if (channel === "whatsapp") {
            window.location.href = "https://wa.me/+50256308598";
        } else if (channel === "contactForm") {
            window.location.href = "https://eleven.fit/contact";
        }*/
    };
    const [popSection, setPopSection] = useState(0);

    const contactMethods = [
        { name: "Email", icon: "📧", channel: "email" },
        { name: "Instagram", icon: "📷", channel: "instagram" },
        { name: "YouTube", icon: "▶️", channel: "youtube" },
        { name: "TikTok", icon: "🎵", channel: "tiktok" },
        //{ name: "WhatsApp", icon: "💬", channel: "whatsapp" },
        //{ name: "Contact Form", icon: "📝", channel: "contactForm" },
      ];

 return (
    <div>
      <main>
        {/* Main Welcome Section */}
        <section id="contact" className="section overlay tint-black-30 height-40vh">
          <div className="section__content">
            <h2 className="general-title">Contact Us</h2>
            <h2 className="font-size-20 color-gray-3">
              {/* ...by "us" we mean "me", for now */}
                {/* get in touch and get a free six pack! */}
                and let's sweat together!
            </h2>
          </div>
        </section>

        {/* Contact Mediums */}
        <section className="section-2 bg-image-floor overlay tint-black-50">
          <div className="section__content">
            {/* <h2 className="general-title text-align-center text-shadow">Get in Touch</h2> */}
                {/* get in touch and get fit immediately! */}
            {/* <div className="general-description">
              get in touch and get ripped!
              </div> */}

            {/* #Pop-up section */}
            {popSection > 0 && 
                <div className="pop-box width-90">
                    {popSection === 1 && 
                    <div>
                        <div className="color-gray-4">You can contact me at my super secret email reserved only for the fittest people in the world:</div>
                        <div className="color-1 font-size-30">oscar@eleven.fit</div>
                    </div>
                    }
                </div>
            }

            <div className="box-container">
              {contactMethods.map((method, index) => (
                <div key={index} className={`box-${index + 1} contact-box`} onClick={() => handleClick(method.channel)}>
                  <span className="contact-name">{method.name}</span>
                  <span className="contact-icon">{method.icon}</span>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Contact;